export default __webpack_public_path__ + "static/media/loyalityIcon.dc7acf13.svg";